import styled from 'styled-components';
import { AllieInput } from '../Input/Input';

export const StyledInputNumberContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--allie-spacing-md);
`;

export const StyledInputNumberButton = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 18px;
  justify-content: center;
  border-radius: 50%;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
  transition: background-color 0.2s, opacity 0.2s;
  color: var(--allie-color-primary-60);

  :hover {
    color: var(--allie-color-primary-80);
  }
`;

export const StyledInputNumber = styled(AllieInput)`
  margin: 0 var(--allie-spacing-sm);
  text-align: center;
  min-width: 27px;
  height: 20px;
  border-style: none;
  &&& {
    --padding-start: 0px;
    --padding-end: 0px;
    --padding-top: 0px;
    --padding-bottom: 0px;
  }
  
  & input {
    text-align: center;
  }

  && input::-webkit-outer-spin-button,
  && input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  && input[type="number"] {
    -moz-appearance: textfield;
  }
`; 